export default class PriceStakDisclaimerModal {
    constructor(moreInfoModal) {
        this.$ = globalThis.jQuery;
        this.handleTriggerKeydown = (e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.openDisclaimer(e);
            }
        };
        this.openDisclaimer = (e) => {
            const trigger = e.currentTarget;
            const title = trigger
                .querySelector(".modalDisclaimerToggleLabel")
                ?.textContent?.trim() ?? "";
            const content = trigger.querySelector(".hidden")?.innerHTML ?? "";
            this._moreInfoModal.open(trigger, title, content);
            this.$("#moreInfoModal").modal("show");
        };
        this._moreInfoModal = moreInfoModal;
    }
    register() {
        const triggers = document.querySelectorAll("[data-target='#ModalPriceStakDisclaimer']");
        for (const trigger of triggers) {
            // The producer's trigger spans have role="button" but no tabindex, so
            // they are unreachable by keyboard as delivered.
            if (!trigger.hasAttribute("tabindex")) {
                trigger.setAttribute("tabindex", "0");
            }
            trigger.addEventListener("click", this.openDisclaimer);
            trigger.addEventListener("keydown", this.handleTriggerKeydown);
        }
    }
}
